import { Location } from '@angular/common';
import { OverlayService, NoticeDefinition } from './../../services/overlay.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { User } from '../../interfaces/user';
import { AbstractDetailsComponent } from '../shared/abstract-details.component';
import { ActivatedRoute } from '@angular/router';
import { Md5 } from 'ts-md5';
import { SapiEntity } from 'app/services/sapi.service';

const md5 = new Md5();

@Component({
	selector: 'user-preferences',
	templateUrl: './user-preferences.component.html',
	styleUrls: ['./user-preferences.component.scss']
})

export class UserPreferencesComponent extends AbstractDetailsComponent implements OnInit {

	@ViewChild('formRef', { static: true }) form: NgForm;

	userInfo: User;
	firstName: string;
	lastName: string;
	email: string;
	changePassword: boolean;
	password: string;
	newPassword: string;
	newPasswordAgain: string;
	passwordCheck: RegExp;
	oldPassword: string;
	entity: any;

	constructor(protected route: ActivatedRoute,
		protected location: Location,
		protected authenticationService: AuthenticationService,
		protected overlayService: OverlayService) {

		super(route, location);

		this.entityConfiguration = {
			name: 'user/me',
			parentPath: '/',
			basePath: '/preferences'
		};
	}


	ngOnInit() {
		super.ngOnInit();
		this.getUser();
		this.passwordCheck = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}'); // at least eight characters, containing at least one lowercase, one uppercase, one digit

		this.entityTranslation = this.translate.instant('USER');
	}

	getUser() {
		this.authenticationService.getUser().subscribe((userInfo: User) => {
			if (userInfo) {
				this.userInfo = userInfo;
				this.firstName = userInfo.firstname;
				this.lastName = userInfo.lastname;
				this.email = userInfo.email;
			}
		});
	}

	load(id: string): Observable<SapiEntity> {
		const loadObservable = super.load(id);
		loadObservable.subscribe(() => {
			if (this.entity) {
				this.getUser();
				this.oldPassword = '';
				this.newPassword = '';
				this.newPasswordAgain = '';
				this.changePassword = false;
			}
		});
		return loadObservable;
	}

	save(force: boolean): Observable<any> {

		if (!this.oldPassword || this.oldPassword === '') {
			this.overlayService.createToast(this.translate.instant('USER_INFO_MSG_NO_PWD'));
			return;
		}

		if (!this.firstName || !this.lastName || !this.email) {
			this.overlayService.createToast(this.translate.instant('USER_INFO_MSG_NO_EMPTY_FIELDS'));
			return;
		} else {
			this.userInfo.firstname = this.firstName;
			this.userInfo.lastname = this.lastName;
		}

		if (this.email.indexOf('@') === -1) {
			this.overlayService.createToast(this.translate.instant('USER_INFO_EMAIL_INVALID'));
			return;
		} else {
			this.userInfo.email = this.email;
		}

		if (this.changePassword) {
			if (this.newPassword || this.newPasswordAgain) {
				if (this.newPassword !== this.newPasswordAgain) {
					this.overlayService.createToast(this.translate.instant('CHANGE_PASSWORD_MSG_NOT_EQUAL'));
					return;
				} else if (!this.passwordCheck.test(this.newPassword) && this.newPassword.length < 16) {
					const notice: NoticeDefinition = {
						icon: 'warning',
						title: this.translate.instant('CHANGE_PASSWORD_INCORRECT'),
						type: 'error',
						contents: this.translate.instant('CHANGE_PASSWORD_REQUIREMENTS_BREAK')
					};
					this.overlayService.createNotice(notice);
					return;
				} else {
					const oldPasswordHash = btoa(md5.start().appendStr(this.oldPassword).end().toString());
					this.authenticationService.changePasswordByHash(oldPasswordHash, this.newPassword).subscribe(
						succes => {
							this.password = this.newPassword;
							this.overlayService.createToast(this.translate.instant('CHANGE_PASSWORD_SUCCESS'));
							this.changePassword = false;
							this.formGroup.markAsPristine();
						},
						error => {
							this.overlayService.createToast(this.translate.instant('CHANGE_PASSWORD_FAILED'));
						}
					);
					return;
				}
			} else {
				this.overlayService.createToast(this.translate.instant('CHANGE_PASSWORD_MSG_EMPTY_FIELDS'));
				return;
			}
		} else {
			this.password = this.oldPassword;
		}

		this.entity = this.userInfo;

		return super.save(true);
	}

}
